/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign, __awaiter, __generator } from "tslib";
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { UnitsLinesVisual, UnitsLinesParams } from '../units-visual';
import { MolecularSurfaceCalculationParams } from '../../../mol-math/geometry/molecular-surface';
import { Lines } from '../../../mol-geo/geometry/lines/lines';
import { computeUnitMolecularSurface } from './util/molecular-surface';
import { computeMarchingCubesLines } from '../../../mol-geo/util/marching-cubes/algorithm';
import { ElementIterator, getElementLoci, eachElement } from './util/element';
import { CommonSurfaceParams, getUnitExtraRadius } from './util/common';
import { Sphere3D } from '../../../mol-math/geometry';
export var MolecularSurfaceWireframeParams = __assign(__assign(__assign(__assign({}, UnitsLinesParams), MolecularSurfaceCalculationParams), CommonSurfaceParams), {
  sizeFactor: PD.Numeric(1.5, {
    min: 0,
    max: 10,
    step: 0.1
  })
}); //

function createMolecularSurfaceWireframe(ctx, unit, structure, theme, props, lines) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, transform, field, idField, params, wireframe, sphere;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , computeUnitMolecularSurface(structure, unit, props).runInContext(ctx.runtime)];

        case 1:
          _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField;
          params = {
            isoLevel: props.probeRadius,
            scalarField: field,
            idField: idField
          };
          return [4
          /*yield*/
          , computeMarchingCubesLines(params, lines).runAsChild(ctx.runtime)];

        case 2:
          wireframe = _b.sent();
          Lines.transform(wireframe, transform);
          sphere = Sphere3D.expand(Sphere3D(), unit.boundary.sphere, props.probeRadius + getUnitExtraRadius(unit));
          wireframe.setBoundingSphere(sphere);
          return [2
          /*return*/
          , wireframe];
      }
    });
  });
}

export function MolecularSurfaceWireframeVisual(materialId) {
  return UnitsLinesVisual({
    defaultProps: PD.getDefaultValues(MolecularSurfaceWireframeParams),
    createGeometry: createMolecularSurfaceWireframe,
    createLocationIterator: ElementIterator.fromGroup,
    getLoci: getElementLoci,
    eachLocation: eachElement,
    setUpdateState: function (state, newProps, currentProps) {
      if (newProps.resolution !== currentProps.resolution) state.createGeometry = true;
      if (newProps.probeRadius !== currentProps.probeRadius) state.createGeometry = true;
      if (newProps.probePositions !== currentProps.probePositions) state.createGeometry = true;
      if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens) state.createGeometry = true;
      if (newProps.includeParent !== currentProps.includeParent) state.createGeometry = true;
    }
  }, materialId);
}